import dom from "../../../dist/jsx-render/dom"
import { ColumnBase } from "./ColumnBase";
import { ChildRow } from "./ChildRow";
import { MsoTable } from "./MsoTable";
import { app } from "../../Frame/App";
import { ITableColumn } from "./ITableColumn";

export class ColumnExpand extends ColumnBase {

    public constructor(table: MsoTable, def: ITableColumn, rootId: string) {
        super(table, def, rootId);
        def.isSizeable = false;
        def.isFilterable = false;
        def.isSortable = false;
    }

    public getContent(row: any): HTMLElement {
        if (this.isCellVisible(row) == true) {
            return <i className="fas fa-chevron-right"></i>; 
        }
        return <div></div>;
    }

    public createCell(rowModel: any, idField: string): HTMLElement {
        const element = super.createCell(rowModel, idField);
        element.setAttribute("data-id", rowModel[idField]);
        element.setAttribute("data-row-id", rowModel["_rowElementId"]);
        if (this.isCellVisible(rowModel) == true) {
             element.addEventListener("click", this.onCellClick);
        }
        return element;
    }

    public updateCell(cell: HTMLElement, model: any): HTMLElement {
        // prevent update of this cell
        return null;
    }

    onCellClick = (ev: MouseEvent) => {
        ev.stopPropagation();
        const cell = ev.currentTarget as HTMLElement;
        const id = cell.getAttribute("data-id");
        const elementId = cell.getAttribute("data-row-id");
        if (cell.hasAttribute("data-child-created")) {
            this.toggle(cell, elementId);
        }
        else {
            this.createChildTable(cell, id, elementId);
        }
    }

    private createChildRow(id: string): HTMLElement {
        if (this.table.props.fixedLayout) {
            return <tr>
                <td></td>
                <td className="mt-sub-table mso-table"
                    id={app.createGuid()}
                    colspan={this.table.columnCount - 1}
                    data-edit-type="1"
                    data-load-url="~/api/tableView/get"
                    data-view-index={this.table.props.viewIndex}
                    data-parent-id={id}
                    data-view-type="None"
                    data-single-template-id="0"
                    data-view-id={this.decimals}
                    data-enable-sort="true"
                    data-fixed-layout={this.table.props.fixedLayout}
                    data-enable-scroll="false">
                </td>
            </tr>
        }
        else {
            return <div className="mt-sub-frame">
                <div className="mt-sub-table mso-table"
                    id={app.createGuid()}
                    data-edit-type="1"
                    data-load-url="~/api/tableView/get"
                    data-view-index={this.table.props.viewIndex}
                    data-parent-id={id}
                    data-view-type="None"
                    data-single-template-id="0"
                    data-view-id={this.decimals}
                    data-enable-sort="true"
                    data-fixed-layout={this.table.props.fixedLayout}
                    data-enable-scroll="false">
                </div>
            </div>
        }
    }

    private createChildTable(cell: HTMLElement, id: string, elementId: string) {
        const row = this.table.getRowComponentByElementId(elementId);
        
        // create new row and insert it
        let newRow = this.createChildRow(id);
        if (row.element.nextElementSibling) {
            row.element.parentElement.insertBefore(newRow, row.element.nextElementSibling);
        }
        else {
            row.element.parentElement.appendChild(newRow);
        }

        if (this.table.props.onCreateChildTable) {
            row.setChildTable(newRow, this.table.props.onCreateChildTable(this.table, id, newRow.querySelector(".mt-sub-table")));
        }
        else {
            let childTable = new MsoTable(newRow.querySelector(".mt-sub-table"));

            // Pass this option to the child table
            childTable.props.addButtonNew = this.table.props.addButtonNew;
            childTable.props.getTextForNewButton = this.table.props.getTextForNewButton;

            row.setChildTable(newRow, childTable);
        }

        // mark as created
        cell.setAttribute("data-child-created", "true");

        // expand it
        this.expand(cell, elementId);
    }

    private toggle(td: HTMLElement, elementId: string) {
        if (td.hasAttribute("data-expanded")) {
            this.collapse(td, elementId);
        }
        else {
            this.expand(td, elementId);
        }
    }

    private collapse(td: HTMLElement, elementId: string) {
        td.removeAttribute("data-expanded");
        var rowComponent = this.table.getRowComponentByElementId(elementId);
        rowComponent.collapse();
        td.firstElementChild.classList.add("fa-chevron-right");
        td.firstElementChild.classList.remove("fa-chevron-down");
    }

    private expand(td: HTMLElement, elementId: string) {
        td.setAttribute("data-expanded", "true");
        var rowComponent = this.table.getRowComponentByElementId(elementId);
        rowComponent.expand();
        td.firstElementChild.classList.remove("fa-chevron-right");
        td.firstElementChild.classList.add("fa-chevron-down");
    }
}